import { MapperBase } from '../../utilities/mapper-base';
import { DocResource } from '../resource/doc.resource';
import { Document } from '../ui/document.model';

export class DocResourceToDocumentMapper extends MapperBase<DocResource, Document> {
	map(source: DocResource): Document {
		const dest = new Document();
		dest.id = source.docId;
		dest.title = source.docTitle;
		dest.pageCount = source.pageCount;
		dest.extension = source.docExtension;

		if(source.batesPrefix && source.batesNumberDigits) {
			const formattedStartNumber = String(source.batesNumberStart).padStart(source.batesNumberDigits, '0');
			dest.batesStartPageStamp = `${source.batesPrefix} ${formattedStartNumber}`;

			const formattedEndNumber = String(source.batesNumberStart + source.pageCount).padStart(source.batesNumberDigits, '0');
			dest.batesEndPageStamp = `${source.batesPrefix} ${formattedEndNumber}`;
		}
		return dest;
	}

}

